<template lang="html">
  <center>
    <i class="fa fa-3x fa-cog fa-spin"></i>
  </center>
</template>

<script>
  export default {}
</script>

<style lang="css" scoped>
  center {
    padding: 40px 0;
  }
</style>
